"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var React = _interopRequireWildcard(require("react"));
var _constants = require("../constants");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _excluded = ["size", "color", "verticalAlign", "hoverColor", "marginLeft"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var LightningIcon = function LightningIcon(props) {
  var size = props.size,
    color = props.color,
    verticalAlign = props.verticalAlign,
    hoverColor = props.hoverColor,
    marginLeft = props.marginLeft,
    rest = (0, _objectWithoutProperties2["default"])(props, _excluded);
  return /*#__PURE__*/React.createElement(StyledSvg, (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 20 20",
    fill: "none"
  }, rest), /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.38263 10.4068C8.71884 10.4068 8.95924 10.732 8.86065 11.0534L7.66191 14.9619L14.3421 8.25024H11.4535C11.063 8.25024 10.8232 7.82265 11.0269 7.48947L13.1598 4H8.9654L5.38972 10.4068H8.38263ZM8.37831 2.5C8.19707 2.5 8.03003 2.59807 7.9417 2.75633L3.66486 10.4195C3.29284 11.086 3.77472 11.9068 4.53807 11.9068H7.02994L5.63573 16.4526C5.32976 17.4501 6.56443 18.1908 7.30053 17.4512L16.7633 7.94405C17.2027 7.50261 16.89 6.75024 16.2671 6.75024H13.2368L15.3697 3.26077C15.5734 2.9276 15.3336 2.5 14.9431 2.5H8.37831Z"
  }));
};
var StyledSvg = _styledComponents["default"].svg.withConfig({
  displayName: "lightning__StyledSvg"
})(["vertical-align:", ";margin-left:", ";&:hover{path{fill:", ";}}"], function (props) {
  return props.verticalAlign;
}, function (props) {
  return props.marginLeft;
}, function (props) {
  return props.hoverColor || props.color;
});
LightningIcon.displayName = 'LightningIcon';
var defaultProps = {
  verticalAlign: 'middle',
  color: _constants.colors.mediumGrey,
  size: '20px',
  marginLeft: '0px'
};
LightningIcon.defaultProps = defaultProps;
var _default = exports["default"] = LightningIcon;